import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { LinearProgressWithLabel } from 'components';
import QuotesQueueResultTable from './QuotesQueueResultTable';


const QuotesQueueProgress = ({handleChangePage, handleChangeRowsPerPage, rowsPerPage, currentPage}) => {
  const [progress, setProgress] = useState(0);
  const [progressFailedCount, setProgressFailedCount] = useState(0);

  const {
    marketingSegmentsQuoteQueue,
    failedMarketingSegmentsQuoteQueue,
    countOfFailedQueueTasks,
    countOfCreatedQueueTasks
  } = useSelector((state: IReduxState) => state.quote);

  useEffect(() => {
    const countInProgress = countOfCreatedQueueTasks - countOfFailedQueueTasks;

    const remainingTasks = countOfCreatedQueueTasks - countInProgress;
    const progress = (remainingTasks * 100) / countOfCreatedQueueTasks;

    setProgressFailedCount(countInProgress);
    setProgress(progress);

    if (progressFailedCount === countInProgress) {
      setProgress(100);
    }
  }, [marketingSegmentsQuoteQueue]);

  return (
    <div className="px-10 w-full">
      {progress !== 100 &&
        <>
          <div className="text-muted flex">
            <div className="mr-1">{'Quotes Creating'}</div>
            <div>{'In Progress...'}</div>
          </div>
          <LinearProgressWithLabel value={progress} />
          <p className="text-muted font-bold uppercase">
            {`Left: ${progressFailedCount}`}
          </p>
        </>
      }
      {!!failedMarketingSegmentsQuoteQueue.length &&
        <QuotesQueueResultTable
          failedTasks={failedMarketingSegmentsQuoteQueue}
          countOfFailedQueueTasks={countOfFailedQueueTasks}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          rowsPerPage={rowsPerPage}
          currentPage={currentPage}
        />
      }
    </div>
  );
};

export default QuotesQueueProgress;
